module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-solid-900.woff?0f7c8f7d7cd80287a094702ebaf8019c";